// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Account$LumiDocuments from "lumi-documents/lib/es6/src/Account.res.js";
import * as LumiExt$LumiDocuments from "lumi-documents/lib/es6/src/LumiExt.res.js";
import * as Saml$LumiAuthentication from "./Saml.res.js";

function cookieLoginPassword(email, password) {
  let payload = {
    email: email,
    password: password
  };
  return LumiRequest.expectJSON(LumiRequest.make("/api/auth/cookie/login/password", "POST", Object.fromEntries([[
      "Content-Type",
      "application/json;charset=utf-8"
    ]]), JSON.stringify(payload), undefined), Document$LumiStore.Document.jsonCodec(LumiExt$LumiDocuments.jsonCodec, Account$LumiDocuments.jsonCodec));
}

function getSamlRequestData(email, destination) {
  let params = [[
      "email",
      email
    ]].concat(destination !== undefined ? [[
        "destination",
        destination
      ]] : []);
  let query = new URLSearchParams(params).toString();
  return LumiRequest.expectJSON(LumiRequest.make("/api/auth/saml/request?" + query, undefined, undefined, undefined, undefined), Saml$LumiAuthentication.RequestData.jsonCodec);
}

function cookieLoginApiKey(apiKey) {
  return LumiRequest.expectJSON(LumiRequest.make("/api/auth/cookie/login/api-key", "POST", Object.fromEntries([[
      "Content-Type",
      "text/plain;charset=utf-8"
    ]]), apiKey, undefined), Document$LumiStore.Document.jsonCodec(LumiExt$LumiDocuments.jsonCodec, Account$LumiDocuments.jsonCodec));
}

function cookieLogout() {
  return LumiRequest.expectNoContent(LumiRequest.make("/api/auth/cookie/logout", "POST", undefined, undefined, undefined));
}

function getAccount() {
  return LumiRequest.expectJSON(LumiRequest.make("/api/auth/account", "GET", undefined, undefined, undefined), Document$LumiStore.Document.jsonCodec(LumiExt$LumiDocuments.jsonCodec, Account$LumiDocuments.jsonCodec));
}

function accountChangePassword(oldPassword, newPassword) {
  let payload = {
    old: oldPassword,
    new: newPassword
  };
  return LumiRequest.expectNoContent(LumiRequest.make("/api/auth/account/change-password", "POST", Object.fromEntries([[
      "Content-Type",
      "application/json;charset=utf-8"
    ]]), JSON.stringify(payload), undefined));
}

function resetPasswordRequest(email, locale) {
  return LumiRequest.expectNoContent(LumiRequest.make(`/api/auth/reset-password/request/` + Locale$LumiI18n.toString(locale), "POST", Object.fromEntries([[
      "Content-Type",
      "application/json;charset=utf-8"
    ]]), JSON.stringify(email), undefined));
}

function resetPasswordConfirm(accountId, secret, password) {
  let payload = {
    accountId: accountId,
    secret: secret,
    password: password
  };
  return LumiRequest.expectNoContent(LumiRequest.make("/api/auth/reset-password/confirm", "POST", Object.fromEntries([[
      "Content-Type",
      "application/json;charset=utf-8"
    ]]), JSON.stringify(payload), undefined));
}

export {
  cookieLoginPassword,
  getSamlRequestData,
  cookieLoginApiKey,
  cookieLogout,
  getAccount,
  accountChangePassword,
  resetPasswordRequest,
  resetPasswordConfirm,
}
/* LumiRequest Not a pure module */
